export default __webpack_public_path__ + "static/media/river.dca2492f.png";